import {DetailTable} from '../../../mapping-classes/detail-table';

export class Onlinekeyrequestedcards implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(requestedCards: any) {
    if (!requestedCards || requestedCards.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = requestedCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(requestedCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'cardNumber',
      'sequenceNumber',
      'status',
      'type',
      'creationDate',
      'registrationDataPreparatorDateTime',
      'notificationDataPreparatorDateTime',
      'registrationPassFactoryDateTime',
      'notificationPassFactoryDateTime',
      'shippingAddress',
      'shipmentType',
      'replacementCardSequenceNumber',
      'requestReason',
    ];
  }

  setRowData(requestedCards) {
    requestedCards.forEach((requestedCard) => {
      if (this.restrictedData) {
        requestedCard.compensationLimit = this.shieldedText;
        requestedCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(requestedCard);
    });
  }
}
